import { css } from '@emotion/react';

const connectorStatusStyles = {
    commonStyles: css({
        padding: '5px 8px',
        fontSize: '12px',
        fontWeight: 800,
        color: '#ffffff',
        display: 'inline',
        borderRadius: '3px',
        width: 'fit-content',
        textTransform: 'uppercase',
    }),
    unavailable: css({
        backgroundColor: '#8A8A8A',
    }),
    available: css({
        backgroundColor: '#3CBC00',
    }),
    busy: css({
        backgroundColor: '#004FC6',
    }),
};

export default connectorStatusStyles;
